import { Provider } from '@servicetitan/react-ioc';
import {
    ApiClientTitanChat,
    CHATBOT_API_CLIENT,
    CHATBOT_CLIENT_SETTINGS,
    CHATBOT_UI_BACKEND_STORE_TOKEN,
    CHATBOT_UI_STORE_TOKEN,
    ChatbotUiBackendStore,
    ChatbotUiStore,
} from '@servicetitan/titan-chatbot-api';
import { FC, PropsWithChildren, useMemo } from 'react';

export const ChatbotProvider: FC<PropsWithChildren> = ({ children }) => {
    const chatbotClientSettings = useMemo<ApiClientTitanChat.IChatbotClientSettingsTitanChat>(
        () => ({
            constructorParametersFactory: () => ({
                baseUrl: '/titan-chatbot',
            }),
            version: '2',
            clientId: 'support-hub',
        }),
        []
    );

    return (
        <Provider
            singletons={[
                {
                    provide: CHATBOT_CLIENT_SETTINGS,
                    useValue: chatbotClientSettings,
                },
                {
                    provide: CHATBOT_API_CLIENT,
                    useClass: ApiClientTitanChat.ChatbotApiClient,
                },
                { provide: CHATBOT_UI_STORE_TOKEN, useClass: ChatbotUiStore },
                { provide: CHATBOT_UI_BACKEND_STORE_TOKEN, useClass: ChatbotUiBackendStore },
            ]}
        >
            {children}
        </Provider>
    );
};
